import React, { Component, Fragment } from "react"
import { Label, Input, FormGroup, Button } from "reactstrap";
import { Copy, Send, Eye, Users, Share2, UserPlus, Check } from "react-feather";
import Radio from "../../theme/@vuexy/radio/RadioVuexy";
import Checkbox from "../../theme/@vuexy/checkbox/CheckboxesVuexy";
import PillActiveBorder from "./tabPills";
import { toast } from "react-toastify";
import { inject, observer } from 'mobx-react';
import ContentActivities from "../common/elements/contentActivity";
import CustomerActivities from "../common/elements/customerActivity";


@inject('sessionStore', 'libraryStore')
@observer
class Invite extends Component {

  state = {
    customerName: "",
    contentTitle: "",
    activeTab: "renderLink",
    shareableLink: "",
    scheduleFor: "now",
    time: "",
    date: "",
    inviteSend: false,
    sendViaEmail: false,
    sendViaSms: false
  }

  componentDidMount = () => {
    const { shareable_link = "", customer_name = "", content_title = "" } = this.props;
    this.setState({
      shareableLink: shareable_link,
      customerName: customer_name,
      contentTitle: content_title
    })
  }

  componentDidUpdate = prevProps => {
    if (prevProps.shareable_link !== this.props.shareable_link) {
      this.setState({
        shareableLink: this.props.shareable_link
      })
    }
    if (prevProps.customer_name !== this.props.customer_name ||
      prevProps.content_title !== this.props.content_title
    ) {
      this.setState({
        customerName: this.props.customer_name,
        contentTitle: this.props.content_title
      })
    }
  }

  changeLink = (event) => {
    this.setState({
      shareableLink: event.target.value
    })
  }

  handleChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value
    })
  }

  setDate = (event) => {
    this.setState({
      date: event.target.value
    })
  }

  setTime = (event) => {
    this.setState({
      time: event.target.value 
    })
  }

  sendInvite = () => {
    let shareVia = []
    this.state.sendViaEmail ? shareVia.push('email') : null;
    this.state.sendViaSms ? shareVia.push('sms') : null;
    if (shareVia.length > 0){
      this.props.share(shareVia);
    }
    else {
      toast.error('Select an Option to Share');
    }
  }

  handleScheduleRadio = (event) => {
    this.setState({
      scheduleFor: event.target.value
    })
  }

  handleCheckbox = (name) => {  
    this.setState({
      [name]: !this.state[name]
    })
  }
  
  share = () => {
    const { activeTab, inviteSend, scheduleFor, sendVia, sendViaEmail, sendViaSms } = this.state;
    const { sharingIcons } = this.props.libraryStore;
    const shareComp = sharingIcons.icons.map((iconObj, i)=>{
      return <span className="mr-3" key={i}>
                <a>
                  <img src={iconObj.img} style={{height: iconObj.name === sharingIcons.currentIcon.name ? "64px" : "32px", 
                              width: iconObj.name === sharingIcons.currentIcon.name ? "64px" : "32px"}} 
                       onClick={(e) => {sharingIcons.currentIcon = iconObj}} />
                </a>
              </span>
    })
    return (
      <div className="mt-5">
        
        {this.state.shareableLink == null || this.state.shareableLink == "" 
            ? (
                <Fragment>
                  <p style={{ color: "#cacaca", fontSize: "14px", textAlign: "center" }}>
                    Click below button to generate sharable link personalised for customer.
                   </p>
                  <FormGroup className="d-flex justify-content-center align-items-center">
                  <Button
                    color="success"
                    onClick={(e) => {this.props.generateCode()}}
                  >
                  Generate Link
                  </Button>
                </FormGroup>
              </Fragment>
              
            ):(
                <Fragment>
                  <p style={{ color: "#cacaca", fontSize: "14px"}}>
                    Copy and Share below link to your customer. Please Donot share this link to any other customer.
                  </p>
                    <FormGroup className="position-relative mb-0">
                      <Input
                      onChange={this.changeLink}
                      id="shareable-link"
                      value={this.state.shareableLink}
                      placeholder="Shareable Link"
                      />
                      <div
                        className="form-control-position"
                        onClick={() => { 
                          navigator.clipboard.writeText(this.state.shareableLink) 
                          toast.success("Link Copied")
                        }}>
                        <Copy size={22} />
                      </div>
                  </FormGroup>

                  <div className="mt-3 mb-3">
                    <p className="mb-2">Share via Instant messenger :</p>
                    <div className="d-flex align-items-center">
                      {shareComp}
                    </div>
                  </div>

                  <div className="mt-5">
                    <p className="mb-2">Share via Email and SMS :</p>
                    <div className="d-flex align-items-center mb-1">
                      <Checkbox
                        className="mr-3"
                        color="primary"
                        name="sendViaEmail"
                        checked={sendViaEmail ? true : false}
                        icon={<Check className="vx-icon" size={16} />}
                        label="Email"
                        onChange={() => { this.handleCheckbox("sendViaEmail")}}
                      />
                      <Checkbox
                        className="mr-3"
                        color="primary"
                        name="sendViaSms"
                        checked={sendViaSms ? true : false}
                        icon={<Check className="vx-icon" size={16} />}
                        label="SMS"
                        onChange={() => { this.handleCheckbox("sendViaSms") }}
                      />
                    </div>
                    <div className="d-flex align-items-center mt-2 mb-2">
                      <Radio
                        label="Now"
                        defaultChecked={true}
                        name="scheduleFor"
                        value="now"
                        className="mr-3"
                        onClick={this.handleScheduleRadio}
                      />
                      <Radio
                        label="Automatic"
                        defaultChecked={false}
                        name="scheduleFor"
                        value="automatic"
                        className="mr-3"
                        onClick={this.handleScheduleRadio}
                      />
                      <Radio
                        label="Later"
                        defaultChecked={false}
                        name="scheduleFor"
                        value="later"
                        className="mr-3"
                        onClick={this.handleScheduleRadio}
                      />
                    </div>
                  </div>

                  <div 
                    className={scheduleFor==="later"
                    ? "d-flex justify-content-between align-items-center flex-wrap mt-2"
                    : "d-flex justify-content-end align-items-center flex-wrap mt-2"
                    }>
                    {
                      scheduleFor === "later" 
                      ? <Fragment>
                          <FormGroup className="mr-3">
                          <Label htmlFor="date_mail">Date</Label>
                          <Input
                            type="date"
                            disabled={scheduleFor === "now" ? true : false}
                            name="date"
                            id="date_mail"
                            onChange={(e) => this.setDate(e)}
                            placeholder="date placeholder"
                          />
                        </FormGroup>
                        <FormGroup className="mr-3">
                          <Label htmlFor="date_time">Time</Label>
                          <Input
                            type="time"
                            name="time"
                            disabled={scheduleFor === "now" ? true : false}
                            id="date_time"
                            onChange={(e) => this.setTime(e)}
                            placeholder="time placeholder"
                          />
                        </FormGroup>
                      </Fragment>
                      : null
                    }
                    {
                      !inviteSend
                        ? (
                          <Button
                            color="primary"
                            className="btn"
                            onClick={(e) => {this.sendInvite()}}
                          >
                            <Send size="20" className="mr-1" />Send
                          </Button>
                        ) : null
                    }
                  </div>
                </Fragment>
              )
            }
      </div>
    )
  }

  activity = () => {
    const { contentSharing } = this.props.sessionStore;
    if (contentSharing) {
      if (contentSharing === "customer") {
        return <ContentActivities />
      } else if (contentSharing === "meeting") {
        return <CustomerActivities />
      }
    } else {
      return
    }
  }

  analytics = () => {
    return <p>Nothing To Show Yet...</p>
  }

  render() {
    let { data } = this.props;
    return (
      <PillActiveBorder
        tabsContent={[
          {
            key: '1',
            tab_name: "Invite",
            tab_content: this.share()
          },
          {
            key: '2',
            tab_name: "Activity",
            tab_content: this.activity()
          },
          {
            key: '3',
            tab_name: "Analytics",
            tab_content: this.analytics()
          }
        ]}
      />
    );
  }
}

export default Invite;